import { matchServerError } from './match-server-error';
export const wrapServiceWithResult = (service, { errorEffect, }) => {
    const entries = Object.entries(service).map(([serviceCallName, serviceCall]) => [
        serviceCallName,
        async (...args) => {
            try {
                const success = await serviceCall(...args);
                return { type: 'SUCCESS', response: success };
            }
            catch (e) {
                const serverError = matchServerError(e);
                if (errorEffect) {
                    try {
                        errorEffect(serverError.baseError, args);
                    }
                    catch (e) {
                        console.log('Error encountered in error effect: ', e);
                    }
                }
                return {
                    type: 'ERROR',
                    error: serverError,
                };
            }
        },
    ]);
    return Object.fromEntries(entries);
};
//# sourceMappingURL=wrap-service-with-result.js.map